var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.748,
    height: 15.75,
    viewBox: "0 0 15.748 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "call",
    d: "M14.875,18a6.625,6.625,0,0,1-3.094-1.055,20.113,20.113,0,0,1-4.859-3.635A18.452,18.452,0,0,1,3.273,8.454C1.978,6.1,2.2,4.863,2.445,4.335A3.288,3.288,0,0,1,3.734,2.953a6.2,6.2,0,0,1,1.007-.535l.1-.043a.94.94,0,0,1,.772-.071,2.259,2.259,0,0,1,.734.563A12.18,12.18,0,0,1,8.176,5.59a2.709,2.709,0,0,1,.36,1.115,1.763,1.763,0,0,1-.448,1.048c-.046.063-.092.123-.136.182-.268.352-.326.453-.288.635a6.668,6.668,0,0,0,1.624,2.409,6.4,6.4,0,0,0,2.381,1.585c.189.041.293-.021.656-.3.052-.04.106-.081.162-.122a1.771,1.771,0,0,1,1.064-.476h0a2.549,2.549,0,0,1,1.12.393,13.42,13.42,0,0,1,2.712,1.821,2.268,2.268,0,0,1,.565.732.948.948,0,0,1-.07.774c-.013.029-.028.061-.042.1a6.2,6.2,0,0,1-.538,1.005,3.285,3.285,0,0,1-1.385,1.286,2.37,2.37,0,0,1-1.04.228Z",
    transform: "translate(-2.257 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.545b8809c6651270fddcc1b0a535b66c.svg";
export { ForwardRef as ReactComponent };